<!--
  Button with loading spinner. Action property example:
  action: {
    caption: 'Press me!',
    class: 'css-class-of-button',
    run: () => alert('hello'),
    loading: false
  }
-->
<template>
    <v-btn @click="run" :loading="loading" :dark="dark" :light="light" :class="action.class">
      {{action.caption}}

      <span slot="loader" class="custom-loader">
        <v-icon :dark="dark" :light="light">cached</v-icon>
      </span>
    </v-btn>
</template>

<script>
export default {
  props: ['action', 'dark', 'light'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    run () {
      this.loading = true
      this.action.promise().then(this.stop, this.stop)
    },
    stop () {
      this.loading = false
    }
  }
}
</script>

<style lang="stylus">
  .custom-loader
    animation: loader 1s infinite
    display: flex

  @-moz-keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

  @-webkit-keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

  @-o-keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

  @keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)
</style>
